import { useClickstreamRecordWidgetFeatureUsage } from 'clickstream/hooks';
import { WidgetType } from 'widgets/WidgetType';
import { usePointedTime } from 'utils/components/TimeSeriesChart/timepoint';
import {
    getBucketIncludingTime,
    IntraDayProfileDataItem,
} from 'widgets/intraDayProfile/chart/IntraDayProfileData';

export function useClickstreamRecordHoverOverLastBucket(
    dataSeries: IntraDayProfileDataItem[]
) {
    const recordHoverOverLastBin = useClickstreamRecordWidgetFeatureUsage(
        WidgetType.INTRA_DAY_PROFILE,
        'hover-over-last-bin'
    );

    const time = usePointedTime('useClickstreamRecordHoverOverLastBucket');

    const bucket =
        time &&
        dataSeries.length > 0 &&
        getBucketIncludingTime(dataSeries, time);

    if (!bucket) {
        return;
    }

    const overLastBucket = dataSeries.indexOf(bucket) === dataSeries.length - 1;
    if (overLastBucket) {
        recordHoverOverLastBin();
    }
}
